module.exports = __webpack_public_path__ + "static/ttf-cc3f83bc269f20fe6f1471493c6a3af4.png";